/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ row: NonNullable<unknown> }} Order_Row_Price_LabelInputs */

const vi_order_row_price_label = /** @type {(inputs: Order_Row_Price_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn giá — dòng ${i?.row}`)
};

/**

* @param {Order_Row_Price_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_row_price_label = /** @type {((inputs: Order_Row_Price_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Row_Price_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_row_price_label(inputs)
});